import { getAuth } from 'firebase/auth';

/**
 * Get Firebase auth token for API authentication
 */
async function getAuthToken() {
  const auth = getAuth();
  const user = auth.currentUser;
  if (!user) {
    throw new Error('Usuario no autenticado');
  }
  return await user.getIdToken();
}

const API_BASE = process.env.REACT_APP_API_URL;

/**
 * Create a Stripe Checkout session for subscription
 * @param {string} orgId - Organization ID
 * @returns {Promise<{checkoutUrl: string}>}
 */
export async function createCheckoutSession(orgId) {
  try {
    const token = await getAuthToken();

    // Build success and cancel URLs
    const baseUrl = window.location.origin;
    const successUrl = `${baseUrl}/app/billing/success?session_id={CHECKOUT_SESSION_ID}`;
    const cancelUrl = `${baseUrl}/app/billing/cancel`;

    const response = await fetch(`${API_BASE}/api/billing/create-checkout`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ orgId, successUrl, cancelUrl }),
    });

    if (!response.ok) {
      const data = await response.json();
      switch (response.status) {
        case 400:
          throw new Error(data.error || 'Parámetros inválidos');
        case 401:
          throw new Error(data.error || 'Sesión expirada. Por favor, inicia sesión de nuevo.');
        case 403:
          throw new Error(data.error || 'No tienes permisos para realizar esta acción');
        case 404:
          throw new Error(data.error || 'Organización no encontrada');
        case 500:
          throw new Error(data.error || 'Error al crear la sesión de pago');
        default:
          throw new Error(data.error || 'Error al crear la sesión de pago');
      }
    }

    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
}

/**
 * Create a Stripe Customer Portal session
 * @param {string} orgId - Organization ID
 * @returns {Promise<{portalUrl: string}>}
 */
export async function createPortalSession(orgId) {
  try {
    const token = await getAuthToken();

    // Build return URL
    const baseUrl = window.location.origin;
    const returnUrl = `${baseUrl}/app/config`;

    const response = await fetch(`${API_BASE}/api/billing/customer-portal`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ orgId, returnUrl }),
    });

    if (!response.ok) {
      const data = await response.json();
      switch (response.status) {
        case 400:
          throw new Error(data.error || 'Parámetros inválidos');
        case 401:
          throw new Error(data.error || 'Sesión expirada. Por favor, inicia sesión de nuevo.');
        case 403:
          throw new Error(data.error || 'No tienes permisos para realizar esta acción');
        case 404:
          throw new Error(data.error || 'No se encontró información de suscripción');
        case 500:
          throw new Error(data.error || 'Error al abrir el portal de pagos');
        default:
          throw new Error(data.error || 'Error al abrir el portal de pagos');
      }
    }

    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
}
